export const TIPO_COMISION = {
  APERTURA: 1,
  ESTUDIO: 2,
  DISPOSICION: 3,
  CORRETAJE: 4,
  OTRA: 5,
  REEMBOLSO: 6,
} as const

export type TipoComisionType =
  (typeof TIPO_COMISION)[keyof typeof TIPO_COMISION]
